import { h } from '@stencil/core';

export const Icon = ({ color = '#2b5195', width = '4rem', height = '4rem' }) => (
  <svg viewBox="0 0 68 68" {...{ color, width, height }}>
    <circle fill={color} cx="33.7" cy="32.5" r="32" />
    <circle cx="33.7" cy="32.5" r="31" fill="#FFFFFF" />
    <polygon fill={color} points="45.8,32.5 27.6,43.3 27.6,21.8 " />
  </svg>
);

export default Icon;
